const sectionIconWithTextCss = `
[data-type='section-icon-with-text'] [data-attribute='icon-with-text-container'] {
  padding: 40px 0;
  border-bottom: solid 1px #d5d9d9;
}

[data-type='section-icon-with-text'] .list-icon-with-text {
  display: flex;
  flex-wrap: wrap;
}

[data-type='section-icon-with-text'] .list-icon-with-text .item-icon-with-text {
  width: calc(100% / 4);
}

[data-type='section-icon-with-text'] .list-icon-with-text .item-icon-with-text .wrap-img {
  height: 70px;
  width: fit-content;
  margin: auto;
}

[data-type='section-icon-with-text'] .list-icon-with-text .item-icon-with-text .wrap-img img {
  height: 100%;
  width: auto;
  display: block !important;
}

[data-type='section-icon-with-text'] .list-icon-with-text .item-icon-with-text .title-item {
  text-align: center;
  margin-top: 8px;
  padding: 0 16px;
  font-size: 16px;
}

@container (max-width: 768px) {
  [data-type='section-icon-with-text'] [data-attribute='icon-with-text-container'] {
    padding: 16px 0;
  }

  [data-type='section-icon-with-text'] .list-icon-with-text .item-icon-with-text {
    width: 50%;
    margin-bottom: 20px !important;
  }
}
`;

export default sectionIconWithTextCss;
